import styled from "@emotion/styled";
import Button from "@/components/Button";

export const DescriptionSectionWrapper = styled.div`
	border: 1px solid #e0e0e0;
	border-radius: 4px;
`;

export const DescriptionUpperWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 30px;
`;

export const DescriptionUpperTitleWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const DescriptionUpperTitleImage = styled.div`
	margin-right: 10px;
	width: 34px;
	height: 34px;
	padding: 5px;
	border-radius: 4px;
	background-color: #5292fa;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const DescriptionUpperTitleText = styled.p`
	font-size: 20px;
	line-height: 28px;
	font-weight: bold;
`;

export const SettingButton = styled(Button)`
	border: 1px solid #a9a9a9;
	height: 34px;
	padding: 5px 10px;
	color: #5e5e5e;
	font-size: 14px;
`;

export const DescriptionUnderWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	row-gap: 0.8rem;
	padding: 32px 30px;
	border-top: 1px solid #e0e0e0;
`;

export const DescriptionUnderContentWrapper = styled.div`
	flex-grow: 1;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	font-size: 14px;
	line-height: 2rem;
`;

export const DescriptionUnderContentTitle = styled.p`
	width: 10rem;
	margin-right: 24px;
	color: #5e5e5e;
`;

export const DescriptionUnderContentDate = styled.p`
	color: #000;
`;

export const DescriptionUnderContentPlan = styled.p`
	color: #ff0000;
	font-weight: bold;
`;

export const DescriptionUnderContentDeadline = styled.p`
	font-size: 14px;
	margin-left: 12px;
	line-height: 25px;
	background-color: #ffd9dd;
	color: #bf0712;
	padding: 0 8px;
	border-radius: 4px;
`;

export const SkillValuePointerCursor = styled.div<{ value: string | number }>`
	position: relative;
	left: ${(props) => props.value};
	bottom: 1rem;
	width: 2px;
	height: 2.2rem;
	background-color: #d91f15;
`;

export const SkillValuePointerDot = styled.div<{ value: string | number }>`
	position: relative;
	left: ${(props) => props.value};
	bottom: 1rem;
	width: 5px;
	height: 5px;
	border-radius: 100px;
	background-color: #d91f15;
`;
